import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { styles } from './CollectionLeaderboardBanner.css';
import React, { useEffect, useRef } from 'react';
import { useTrackingContext } from '../Tracking';
import { Link } from '../PlatformFunctionality';
import { useIsOnScreen } from '../hooks/useIsOnScreen/useIsOnScreen';

export interface CollectionLeaderboardBannerProps {
  href: string;
  desktopImage: React.ReactNode;
  mobileImage: React.ReactNode;
  trackingData?: {
    name?: string;
    brand?: string;
    category?: string;
    index?: number;
  };
  landscapeGrid?: boolean;
}

export const CollectionLeaderboardBanner = ({
  href,
  desktopImage,
  mobileImage,
  trackingData,
  landscapeGrid,
}: CollectionLeaderboardBannerProps) => {
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const isOnScreen = useIsOnScreen(anchorRef, { persistOnceSeen: true });
  const { tracker } = useTrackingContext();
  const isDesktop = useBreakpoint('lg', 'up');

  useEffect(() => {
    if (isOnScreen) {
      tracker.trackCustomEvent({ event: 'internal promotion impression', gaipElement: anchorRef.current });
    }
  }, [isOnScreen, tracker]);

  const trackingDataToDataAttributes = () => {
    if (!trackingData) return {};
    return {
      'data-gaip': 'true',
      'data-gaip-category': trackingData.category ?? '',
      'data-gaip-brand': trackingData.brand ?? '',
      'data-gaip-type': 'leaderboard',
      'data-gaip-position': trackingData.index,
      'data-gaip-has-onclick': 'true',
      'data-gaip-url': href ?? '',
      'data-gaip-id': trackingData.name ?? '',
      'data-testid': 'collection-leaderboard-banner',
    };
  };

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
    tracker.trackCustomEvent({ event: 'internal promotion click', gaipElement: anchorRef.current });
  };

  return (
    <div className={styles.leaderboard({ landscapeGrid })} data-testid="collection-leaderboard-banner">
      <Link onClick={handleClick} ref={anchorRef} href={href} {...trackingDataToDataAttributes()}>
        {isDesktop ? desktopImage : mobileImage}
      </Link>
    </div>
  );
};
